import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { backUrl } from "../../config";

const redPath = "categoryApi"; // change
const tagApi = "categories"; // change

export const categoryApi = createApi({
  reducerPath: redPath,
  baseQuery: fetchBaseQuery({
    baseUrl: backUrl,
    tagTypes: [tagApi],
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.accessToken;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    getCategories: build.query({
      // change
      query: (param) => `${tagApi}${param ? param : ""}`,
      providesTags: [tagApi],
    }),
    createCategory: build.mutation({
      // change
      query: (newData) => ({
        url: `${tagApi}`,
        method: "POST",
        body: {
          data: {
            ...newData,
          },
        },
      }),
      invalidatesTags: [tagApi],
    }),
    updateCategory: build.mutation({
      // change
      query: (newData) => ({
        url: `${tagApi}/${newData.id}`,
        method: "PUT",
        body: {
          data: {
            ...newData.updated,
          },
        },
      }),
      invalidatesTags: [tagApi],
    }),
  }),
});

export const {
  useGetCategoriesQuery,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
} = categoryApi; // change
